var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-component",style:('background-image: url(' + _vm.bannerUrl + ')')},[_c('img',{staticClass:"banner",attrs:{"src":_vm.bannerUrl,"alt":"宣传图"}})])}
var staticRenderFns = []

export { render, staticRenderFns }